import {TFormSelectOption} from "@housebets/housebets-x-package";
import {LocalType} from "app/types/common";

// export const langOpt: TFormSelectOption[] = [
//     {id: LocalType.En, name: "Eng", icon: "/img/flags/4x3/gb.svg"},
//     {id: LocalType.Fr, name: "Fra", icon: "/img/flags/4x3/fr.svg"},
//     {id: LocalType.Zh, name: "中文", icon: "/img/flags/4x3/cn.svg"}, // оставлено оригинальное, т.к. уже кратко
//     {id: LocalType.Es, name: "Esp", icon: "/img/flags/4x3/es.svg"},
//     {id: LocalType.Pt, name: "Por", icon: "/img/flags/4x3/pt.svg"},
//     {id: LocalType.Ko, name: "Kor", icon: "/img/flags/4x3/kr.svg"},
//     {id: LocalType.Ja, name: "日本", icon: "/img/flags/4x3/jp.svg"}, // оставлено оригинальное, кратко и понятно
//     {id: LocalType.De, name: "Deu", icon: "/img/flags/4x3/de.svg"},
//     {id: LocalType.Hu, name: "Hun", icon: "/img/flags/4x3/hu.svg"},
//     {id: LocalType.Tr, name: "Tur", icon: "/img/flags/4x3/tr.svg"},
//     {id: LocalType.Ru, name: "Рyc", icon: "/img/flags/4x3/ru.svg"},
//     {id: LocalType.Vi, name: "Vie", icon: "/img/flags/4x3/vn.svg"},
// ];

export const langOpt: TFormSelectOption[] = [
    {
        id: LocalType.En,
        name: "English",
        shortName: 'Eng',
        icon: "/img/flags/4x3/gb.svg",
    },
    {
        id: LocalType.Fr,
        name: "Français",
        shortName: 'Fra',
        icon: "/img/flags/4x3/fr.svg",
    },
    {
        id: LocalType.Zh,
        name: "中文",
        shortName: 'Zh',
        icon: "/img/flags/4x3/cn.svg",
    },
    {
        id: LocalType.Es,
        name: "Español",
        shortName: 'Esp',
        icon: "/img/flags/4x3/es.svg",
    },
    {
        id: LocalType.Pt,
        name: "Português",
        shortName: 'Por',
        icon: "/img/flags/4x3/pt.svg",
    },
    {
        id: LocalType.Ko,
        name: "한국어",
        shortName: "한국어",
        icon: "/img/flags/4x3/kr.svg",
    },
    {
        id: LocalType.Ja,
        name: "日本語",
        shortName: "日本",
        icon: "/img/flags/4x3/jp.svg",
    },
    {
        id: LocalType.De,
        name: "Deutsch",
        shortName: 'Deu',
        icon: "/img/flags/4x3/de.svg",
    },
    {
        id: LocalType.Hu,
        name: "Magyar",
        shortName: 'Hun',
        icon: "/img/flags/4x3/hu.svg",
    },
    {
        id: LocalType.Tr,
        name: "Türkçe",
        shortName: 'Tur',
        icon: "/img/flags/4x3/tr.svg",
    },
    {
        id: LocalType.Ru,
        name: "Русский",
        shortName: 'Рyc',
        icon: "/img/flags/4x3/ru.svg",
    },
    {
        id: LocalType.Vi,
        name: "Tiếng Việt",
        shortName: 'Vie',
        icon: "/img/flags/4x3/vn.svg",
    },
];

export const currencyOpt: TFormSelectOption[] = [
    {
        id: "usd",
        name: "USD $",
    },
    {
        id: "eur",
        name: "EURO €",
    },
];
